const SCROLL_DELTA = 6;

export function initializeFixedHeader() {
  const header = document.querySelector('.site-header');

  if (!header) return;

  let lastScrollY = window.scrollY;
  let frame = null;

  const showHeader = () => header.classList.remove('is-hidden');

  const updateHeader = () => {
    frame = null;

    const scrollY = Math.max(0, window.scrollY);
    const scrollDifference = scrollY - lastScrollY;
    const menuIsOpen = header.querySelector('.hamburger[aria-expanded="true"]');

    header.classList.toggle('is-scrolled', scrollY > 0);

    if (scrollY <= header.offsetHeight || scrollDifference < -SCROLL_DELTA || menuIsOpen) {
      showHeader();
    } else if (scrollDifference > SCROLL_DELTA && !header.matches(':focus-within')) {
      header.classList.add('is-hidden');
    }

    lastScrollY = scrollY;
  };

  const scheduleUpdate = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateHeader);
  };

  header.addEventListener('focusin', showHeader);
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  updateHeader();
}
